import './i18n/translations';
import I18n from './i18n/i18n';

const fieldDataVar = name => {
  const el = document.querySelector(`[name="${name}"]:checked`) ||
    document.querySelector(`[name="${name}"]`);
  return el && (el.dataset.var || el.value.toLowerCase().replace(/ /, '_'));
};

const err = msg =>
  console.error(msg);

export function replaceVariables(text) {
  return text.replace(/\[([\w-]+)]/g, (match, group) => {
    let value = fieldDataVar(group);
    if (value == '') {value = 'default';}
    if(value) { return value; } else { err(`Missing field: ${group}`); }
  });
}

export function replaceTranslations(text) {
  return text.replace(/%{([^}\s]+)}/g, (match, group) => {
    const key = `leadform.${group}`;
    const translation = I18n.translate(key, { defaults: i18n_defaults(key) });
    if(translation) { return translation; } else { err(`Missing translation: ${key}`); }
  });
}

export default function updateTexts(panel) {
  [...panel.querySelectorAll('[data-text]')].forEach(element => {
    const { text } = element.dataset;
    if(text.indexOf('%{[') === -1) {
      if(element.nodeName === 'INPUT') {
        element.value = replaceTranslations(replaceVariables(text));
      }
      else {
        element.innerHTML = replaceTranslations(replaceVariables(text));
      }
    }
  });
}

export function retrieveFormSelectOptions(name, dependant) {
  const formatted_dependant = dependant.toLowerCase().replace(/ /g,'_');
  const key = `leadform.select_options.${name}.${formatted_dependant}`;
  const translation = I18n.translate(key, {defaults: i18n_defaults(key)});
  if(translation) { return translation; } else { err(`Missing translation: ${key}`); }
}

function i18n_defaults(key){
  const defaultScope = key.replace(/[^.]+$/, 'default');
  return [{ scope: defaultScope }, { message: '' }];
}

export function translateKey(key){
  return I18n.translate(key, { defaults: i18n_defaults(key) });
}



// WEBPACK FOOTER //
// ./client/app/scripts/principles/leadform-i18n.js